var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _ellipse, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportInitiatedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Export_Initiated",
    "data-name": "Export Initiated",
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.538,
    height: 135.155,
    viewBox: "0 0 128.538 135.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M621.061,195.51a2.982,2.982,0,0,0-2.726-1.824H563.911a2.951,2.951,0,0,0-2.95,2.95v68.85a2.951,2.951,0,0,0,2.95,2.95h54.424a2.954,2.954,0,0,0,2.95-2.95V196.637A2.9,2.9,0,0,0,621.061,195.51Zm-.431,69.975a2.3,2.3,0,0,1-2.293,2.293H563.911a2.294,2.294,0,0,1-2.293-2.293h0V196.637a2.3,2.3,0,0,1,2.293-2.293h54.424a2.306,2.306,0,0,1,2.13,1.446,2.571,2.571,0,0,1,.086.259,2.273,2.273,0,0,1,.079.592Z",
    transform: "translate(-560.961 -193.686)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M640.918,223.654H624.525a1.311,1.311,0,1,1,0-2.623h16.392a1.312,1.312,0,1,1,0,2.623Z",
    transform: "translate(-592.176 -207.398)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M640.918,237.464H624.525a1.311,1.311,0,1,1,0-2.623h16.392a1.312,1.312,0,1,1,0,2.623Z",
    transform: "translate(-592.176 -214.322)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M595.443,230.779H583.461a1.477,1.477,0,0,1-1.475-1.475V215.167a1.477,1.477,0,0,1,1.475-1.475h11.982a1.477,1.477,0,0,1,1.475,1.475V229.3A1.477,1.477,0,0,1,595.443,230.779Z",
    transform: "translate(-571.504 -203.718)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M619.916,265.74H582.869a1.311,1.311,0,1,1,0-2.623h37.047a1.311,1.311,0,0,1,0,2.623Z",
    transform: "translate(-571.289 -228.501)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M619.916,279.554H582.869a1.311,1.311,0,1,1,0-2.623h37.047a1.311,1.311,0,0,1,0,2.623Z",
    transform: "translate(-571.289 -235.428)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M619.916,293.359H582.869a1.311,1.311,0,1,1,0-2.623h37.047a1.311,1.311,0,1,1,0,2.623Z",
    transform: "translate(-571.289 -242.35)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M619.916,307.172H582.869a1.311,1.311,0,1,1,0-2.623h37.047a1.311,1.311,0,1,1,0,2.623Z",
    transform: "translate(-571.289 -249.276)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M619.916,320.978H582.869a1.311,1.311,0,1,1,0-2.623h37.047a1.311,1.311,0,0,1,0,2.623Z",
    transform: "translate(-571.289 -256.199)",
    fill: "#ccc"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M670.618,276.551a3.789,3.789,0,0,0-3.465-2.318H597.989a3.751,3.751,0,0,0-3.749,3.749v87.5a3.751,3.751,0,0,0,3.749,3.749h69.166a3.754,3.754,0,0,0,3.749-3.749v-87.5a3.682,3.682,0,0,0-.284-1.431Z",
    transform: "translate(-577.648 -234.075)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83187",
    "data-name": "Path 83187",
    d: "M669.461,368.621H604.824c-.931,0-1.661-1.02-1.661-2.32V285.134c0-1.3.731-2.32,1.661-2.32h64.637c.932,0,1.661,1.02,1.661,2.32V366.3C671.121,367.6,670.391,368.621,669.461,368.621Z",
    transform: "translate(-582.122 -238.377)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_336-2",
    "data-name": "Path 336",
    d: "M670.618,276.551a3.789,3.789,0,0,0-3.465-2.318H597.989a3.751,3.751,0,0,0-3.749,3.749v87.5a3.751,3.751,0,0,0,3.749,3.749h69.166a3.754,3.754,0,0,0,3.749-3.749v-87.5a3.682,3.682,0,0,0-.284-1.431Zm-.548,88.93a2.92,2.92,0,0,1-2.917,2.917H597.989a2.917,2.917,0,0,1-2.917-2.915v-87.5a2.921,2.921,0,0,1,2.917-2.917h69.166a2.931,2.931,0,0,1,2.707,1.835,3.216,3.216,0,0,1,.11.329,2.888,2.888,0,0,1,.1.753Z",
    transform: "translate(-577.648 -234.075)",
    fill: "#a6b7bd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M695.856,312.315H675.023a1.667,1.667,0,0,1,0-3.333h20.833a1.667,1.667,0,1,1,0,3.333Z",
    transform: "translate(-617.319 -251.499)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M695.856,329.865H675.023a1.667,1.667,0,0,1,0-3.333h20.833a1.667,1.667,0,1,1,0,3.333Z",
    transform: "translate(-617.319 -260.299)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M638.061,321.37H622.836a1.877,1.877,0,0,1-1.875-1.875V301.528a1.877,1.877,0,0,1,1.875-1.875h15.225a1.877,1.877,0,0,1,1.875,1.875v17.966A1.877,1.877,0,0,1,638.061,321.37Z",
    transform: "translate(-591.047 -246.821)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M669.166,365.8H622.083a1.667,1.667,0,1,1,0-3.333h47.083a1.667,1.667,0,0,1,0,3.333Z",
    transform: "translate(-590.774 -278.318)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M669.161,383.351H622.078a1.667,1.667,0,1,1-.009-3.333h47.092a1.667,1.667,0,1,1,0,3.333Z",
    transform: "translate(-590.769 -287.119)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M669.166,400.9H622.083a1.667,1.667,0,0,1,0-3.333h47.083a1.667,1.667,0,1,1,.009,3.333Z",
    transform: "translate(-590.774 -295.919)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M669.161,418.451H622.078a1.667,1.667,0,1,1-.009-3.333h47.092a1.667,1.667,0,1,1,0,3.333Z",
    transform: "translate(-590.769 -304.719)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M669.161,436H622.078a1.667,1.667,0,1,1-.009-3.333h47.092a1.667,1.667,0,0,1,0,3.333Z",
    transform: "translate(-590.769 -313.519)",
    fill: "#e6e6e6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 26.923,
    cy: 26.923,
    rx: 26.923,
    ry: 26.923,
    transform: "translate(74.693 6.794)",
    fill: "#5479f7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M762,246.123v14.853h-7.649V246.123h-3.571l3.7-6.4,3.7-6.405,3.7,6.405,3.7,6.405Z",
    transform: "translate(-656.14 -213.557)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportInitiatedIcon);
export default __webpack_public_path__ + "static/media/export_initiated_icon.04c2a964a9d66ade4ed086118c123d15.svg";
export { ForwardRef as ReactComponent };